import { css } from 'lit';
export default css `
    :host {
        --spinner-flex-direction: column;
        --spinner-size: 1.75rem;
        --spinner-width: 0.3rem;
        align-items: center;
        display: inline-flex;
        flex-direction: var(--spinner-flex-direction);
        font-size: var(--font-size-xs);
    }

    :host([size='xl']) {
        --spinner-size: 4rem;
        --spinner-width: 0.5rem;
    }

    .spinner {
        align-self: center;
        animation: spin 1s cubic-bezier(0.47, 0, 0.745, 0.715) infinite;
        -webkit-animation: spin 1s cubic-bezier(0.47, 0, 0.745, 0.715) infinite; /* Safari */
        -moz-animation: spin 1s cubic-bezier(0.47, 0, 0.745, 0.715) infinite; /* firefox */
        -o-animation: spin 1s cubic-bezier(0.47, 0, 0.745, 0.715) infinite; /* opera */
        border: var(--spinner-width) solid var(--color-ui-08);
        border-radius: var(--radius-round);
        border-top: var(--spinner-width) solid var(--color-primary);
        border-right: var(--spinner-width) solid var(--color-primary);
        box-sizing: border-box;
        height: var(--spinner-size);
        justify-self: center;
        margin-bottom: var(--spacing-s);
        width: var(--spinner-size);
    }

    :host([orientation='vertical']) .text {
        text-align: center;
    }

    :host([orientation='horizontal']) {
        --spinner-flex-direction: row;
    }

    :host([orientation='horizontal']) .spinner {
        margin-right: var(--spacing-m);
        margin-bottom: 0;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* safari */
    @-webkit-keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* firefox */
    @-moz-keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
